import BaseController from './base_controller'

export default class extends BaseController {
  static targets = ['dialog']
  static values = { createUrl: String }

  connect() {
    this.boundOnRatingSubmitted = this.onRatingSubmitted.bind(this)
    window.addEventListener('amplitude:survey-submitted', this.boundOnRatingSubmitted)
  }

  disconnect() {
    window.removeEventListener('amplitude:survey-submitted', this.boundOnRatingSubmitted)
  }

  async onRatingSubmitted(event) {
    const rating = event.detail?.rating
    if (rating == null) return

    const response = await this.request(this.createUrlValue, { rating })
    if (response?.ok) this.dialogTarget.showModal()
  }

  async accept() {
    await this.request(`${this.createUrlValue}/participation`, {})
    this.dialogTarget.close()
  }

  decline() {
    this.dialogTarget.close()
  }

  request(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content,
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).catch(() => null)
  }
}
